import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "ModalSortBy" */ /* webpackPrefetch: true */
      './ModalSortBy.component'
    ),
);
